import React from 'react';
import styled  from 'styled-components';
import CountUp from '@/components/landing/common/CountUp'
import { breakpoints } from '@/layouts/breakpoints'


const StyledComp = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 90px;
  padding: 40px;
  border-top: 1px solid rgba(var(--greyr), 0.3);
  margin-top: 80px;
  margin-bottom: 60px;
  border-bottom: 1px solid rgba(var(--greyr), 0.3);

  .stat{
    min-width: 150px;
    span{
      color: var(--grey);
      font-size: 12px;
      padding-top: 6px;
    }
    b {
      display: block;
      color: black;
      font-size: 16px;
      min-width: 100%;
      span{
        color: black;
        font-size: 16px;
        padding-right: 6px;
      }
    }
  }

  @media (max-width: ${breakpoints.large}) {
    flex-direction: column;
    gap: 80px;
    padding: 80px;
    margin-bottom: 0;
display: none;
    .stat{
      b, b span{
        font-size: 32px;

        @media (max-width: ${breakpoints.small}) {
            font-size: 22px;
        }
      }
      span{
        font-size: 22px;

        @media (max-width: ${breakpoints.small}) {
          font-size: 14px;
        }
      }
    }

  }
`;

const Comp = ({}) => {
  return (
    <StyledComp>
      <div className="stat">
        <b className="sans">
          <CountUp from={0}
            to={14}
            separator=","
            direction="up"
            duration={2}
            className="count-up-text"
          />

          BILLION+</b>
        <span> Rows of Data </span>
      </div>

      <div className="stat">
        <b className="sans">
          <CountUp from={0}
            to={2}
            separator=","
            direction="up"
            duration={1}
            className="count-up-text"
          />

          PETABYTES</b>
        <span> Raw Data </span>
      </div>

      <div className="stat">
        <b className="sans"> ~
          <CountUp from={10}
            to={44}
            separator=","
            direction="up"
            duration={2}
            className="count-up-text"
          />
          MILLION </b>
        <span> Daily Requests </span>
      </div>


      <div className="stat">
        <b className="sans">
          <CountUp from={99}
            to={99.9999}
            separator=","
            direction="up"
            duration={1}
            className="count-up-text"
          />

          % </b>
        <span> Uptime </span>
      </div>
    </StyledComp>
  );
};

export default Comp;
